import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import style from './SendFeedback.module.css';
import { useTranslation } from 'react-i18next';
/* import { Footer } from '../../components'; */
import { Alert } from "../../utils";
import { Toaster } from "sonner";
import axios from "axios";

const SendFeedback = () => {
  const [formData, setFormData] = useState({ email: "", comments: "", screenshot: "", formType: "Send Feedback" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleFormControl = (e) => {
    const { name, value, files } = e.target;
    if (name === "screenshot") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const email = e.target.email.value;
    const comments = e.target.comments.value;

    if (email === "") {
      setLoading(false);
      return Alert.error("You must enter an email");
    }

    if (comments === ""){
      setLoading(false);
      return Alert.error("You must enter a message / comment");
    }
    try {
      handleSendEmail(formData);
      setLoading(false);
      setSubmitted(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  const handleSendEmail = async (dataEmail) => {
    const formData = new FormData();

    for (const key in dataEmail) {
      formData.append(key, dataEmail[key]);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_V2}/api/send-email/form`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60000, // Timeout de 60 segundos
        }
      );
      //console.log("Respuesta del servidor:", response);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return (
    <Container className="p-0" fluid>
      <Row className={`m-0 py-4 py-md-5 justify-content-center ${style.header}`}>
        <Col xs={11} md={7} lg={6} className='align-content-center'>
          <h1 className={`mb-md-4 ${style.headerTitle}`}>
            {t("Send Feedback")}
          </h1>
        </Col>
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={7} lg={6} xl={5} className='mt-4'>
          <p className={style.txt}>{t("sendFeedbackTxt1")}</p>
        </Col>
      </Row>
      <Row className='justify-content-center my-4 mx-0'>
        <Col xs={11} md={7} lg={6} xl={5} className='align-content-center mb-4'>
          <Form onSubmit={handleSubmit} className="mt-2">
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label className={style.formLabels}>{t("Email address")}</Form.Label>
                  <Form.Control
                    isInvalid={
                      formData.email.length > 0 &&
                      !formData.email.match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                      )
                    }
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("You must write a valid email")}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="comments">
                  <Form.Label className={style.formLabels}>{t("Message / Comments")}</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="comments"
                    value={formData.comments}
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="formFileSm" className="mb-3">
                  <Form.Label className={style.formLabels}>{t("Screenshot (optional)")}</Form.Label>
                  <Form.Control
                    type="file"
                    size="sm"
                    name="screenshot"
                    onChange={handleFormControl}
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
            </Row>
            {submitted ?
              <Button type="submit" className={style.submitBtn} disabled={true}>
                {t("Thank you!")}
              </Button>
              :
              <Button type="submit" className={style.submitBtn}>
                {t("Submit")}{" "}
                {loading && (
                <Spinner
                  as="span"
                  size="sm"
                  animation="grow"
                  role="status"
                />
              )}
              </Button>
            }
          </Form>
          <Toaster richColors position="bottom-center" closeButton />
        </Col>
      </Row>
      {/* <Footer /> */}
    </Container>
  )
}

export default SendFeedback;